var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-content-center"},[_c('ProgressSpinner',{style:({ width: _vm.size, height: _vm.size }),attrs:{"strokeWidth":_vm.strokeWidth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }